import axios from "axios";
import { useQuery } from "@tanstack/react-query";
import { API_BASE_RELATIVE_PATH, API_BASE_PATH } from "../Config/Config";

const fetchNlpSteps = async (id) => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  const user = JSON.parse(userDetails);

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getnlpfortc&companyid=${user.companyid}&testcaseid=${id}`,
  );

  return response.data;
};

const useNlpStepQuery = (id) => {
  return useQuery({
    queryKey: ["nlpsteps", id],
    queryFn: () => fetchNlpSteps(id),
    retry: true,
    enabled: false,
    cacheTime: 90000,
    refetchInterval: false,
    refetchIntervalInBackground: false,
    staleTime: Infinity,
  });
};

export default useNlpStepQuery;
